/**
 * Import Dependency
 */
import React, { Component } from 'react'
import ReactSwiper from 'react-id-swiper'
// import math from 'lodash/math';
// import collection from 'lodash/collection';
// import lang from 'lodash/lang';
import { Flex } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from '../assets/styles/components/Carousel'
import cloudinary from 'helpers/cloudinary'
import { IPHONEX_WIDTH } from '../constants/mediaQuery'
import findMoreIcon from '../assets/icons/find-more.svg'

/**
 * Import Antd Mobile Design
 */

/**
 * Import Container
 */
import StepperContainer from '../containers/components/Stepper'

/**
 * Declare Variable
 */

/**
 * Component
 */
class CarouselComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      carouselHeight: Math.round(window.innerWidth * 0.4933333),
    }
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.resizeDimension)
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.resizeDimension)
  }

  resizeDimension = () => {
    this.setState({
      carouselHeight: Math.round(window.innerWidth * 0.4933333),
    })
  }

  onSlideItemClick = (index, image, name, desc) => () => {
    const {
      triggerSlideImageModal,
    } = this.props

    if (this.swiper.activeIndex === index) {
      triggerSlideImageModal(image, name, desc)
    } else {
      this.swiper.slideTo(index)
    }
  }

  jumpToCategory = (categoryId) => {
    const { history } = this.props
    const path = '/category/set/' + categoryId
    history.push(path)
    console.info('route changed', path)
  }

  renderActionBtn = (item, itemId, itemName, itemPrice, itemGroups, itemDiscount, index, priceUndetermined, isPromotedSet, categoryId) => {
    const { classes, intl } = this.props
    const carouselPromoteSetBtnStyle = cx(classes['carousel-promote-set-button'])
    const carouselStepperStyle = cx(classes['carousel-stepper'])
    const carouselPromoteSetBtnText = intl.formatMessage({ id: 'carousel.set.btn' })
    if (isPromotedSet) {
      return (
        <Flex className={carouselStepperStyle} style={{ padding: '0px' }}>
          <div onClick={(e) => { this.jumpToCategory(categoryId); e.stopPropagation() }} className={carouselPromoteSetBtnStyle}>{carouselPromoteSetBtnText}</div>
        </Flex>
      )
    } else {
      return (
        <Flex className={carouselStepperStyle}>
          <div id='StepperContainer' onClick={(e) => e.stopPropagation()}>
            <StepperContainer
              item={item}
              itemId={itemId}
              itemName={itemName}
              itemPrice={itemPrice}
              itemGroups={itemGroups}
              itemDiscount={itemDiscount}
              stepperWithSlideTo={this.stepperWithSlideTo(index)}
              priceUndetermined={priceUndetermined}
            />
          </div>
        </Flex>)
    }
  }

  renderPrice = (priceUndetermined, price, discount, isPromotedSet) => {
    if (priceUndetermined) {
      const { intl } = this.props
      const undeterminedPriceText = intl.formatMessage({ id: 'summary.undetermined.price' })
      return undeterminedPriceText
    }
    return price - discount
  }

  renderPriceAttrText = (isPromotedSet) => {
    if (!isPromotedSet) {
      return (<div />)
    }
    const { classes, intl } = this.props
    const carouselItemPriceStyle = cx(classes['carousel-item-price'])
    const priceAttrText = intl.formatMessage({ id: 'carousel.price.attr' })
    return (<div className={carouselItemPriceStyle} style={{ fontSize: '13px' }}>{priceAttrText}</div>)
  }

  renderCarouselItems = () => {
    const {
      classes,
      promoItems,
      merchant,
      intl,
    } = this.props

    const carouselBlockWrapStyle = cx(classes['carousel-block-wrap'])
    const carouselBlockStyle = cx(classes['carousel-block'])
    const carouselItemDetailStyle = cx(classes['carousel-item-detail'])
    const carouselItemNameStyle = cx(classes['carousel-item-name'])
    const carouselItemSoldOutSoonStyle = cx(classes['carousel-item-sold-out-soon'])
    const carouselItemPriceWrapStyle = cx(classes['carousel-item-price-wrap'])
    const carouselItemPricePrefixStyle = cx(classes['carousel-item-price-prefix'])
    const carouselItemPriceStyle = cx(classes['carousel-item-price'])
    const carouselItemDescriptionStyle = cx(classes['carousel-item-description'])
    const carouselItemCoverImageWrapStyle = cx(classes['carousel-item-cover-image-wrap'])
    const carouselItemCoverImageStyle = cx(classes['carousel-item-cover-image'])
    const soldOutSoonText = intl.formatMessage({ id: 'soldOutSoon' })
    const carouselFindMoreButtonStyle = classes['carousel-find-more-button']

    const promoItem = (promoItems
      .filter(item => {
        if (merchant.setting.inventory && item.inventory === 0) {
          return false
        }
        return true
      })
      .map((item, index) => {
        const carouselImage = cloudinary.transformation(item.image, `w_${IPHONEX_WIDTH}`)
        const ellipsis = item.name.length > 23
        const itemNameText = ellipsis ? `${item.name.substr(0, 23)}...` : item.name
        const isSoldOutSoon = merchant.setting.inventory && item.inventory <= item.stockAlertLevel

        return (
          <div key={index} className={carouselBlockWrapStyle} >
            <div
              className={carouselBlockStyle}
              style={{ minHeight: `${this.state.carouselHeight + 110}px` }}
              onClick={this.onSlideItemClick(index, item.image, item.name, item.desc)}
            >
              <div
                className={carouselItemCoverImageWrapStyle}
                style={{ minHeight: `${this.state.carouselHeight}px`, lineHeight: `${this.state.carouselHeight}px` }}
              >
                <img
                  className={carouselItemCoverImageStyle}
                  width='100%'
                  src={carouselImage}
                  alt=''
                />
              </div>

              <div className={carouselItemDetailStyle}>
                <section>
                  <Flex align='start'>
                    <div className={carouselItemNameStyle}>
                      <div>{itemNameText}</div>
                      {isSoldOutSoon && <div className={carouselItemSoldOutSoonStyle}>{soldOutSoonText}</div>}
                    </div>
                    <div className={carouselItemPriceWrapStyle}>
                      {
                        item.discount > 0 && (
                          <React.Fragment>
                            <div className={cx(classes['carousel-price-discount-amount'])}>
                              <FontAwesomeIcon icon='dollar-sign' />
                              {this.renderPrice(item.priceUndetermined, item.price, 0, item.step)}
                            </div>
                            {this.renderPriceAttrText(item.step)}
                          </React.Fragment>
                        )
                      }

                      <div className={carouselItemPricePrefixStyle}>
                        <FontAwesomeIcon icon='dollar-sign' />
                      </div>
                      <div className={carouselItemPriceStyle}>
                        {this.renderPrice(item.priceUndetermined, item.price, item.discount, item.step)}
                      </div>
                      {this.renderPriceAttrText(item.step)}
                    </div>
                  </Flex>
                  {
                    item.desc && (
                      <Flex className={carouselItemDescriptionStyle}>
                        {item.desc}
                      </Flex>
                    )
                  }
                </section>

                {
                  ellipsis && (
                    <Flex justify='end' className={carouselFindMoreButtonStyle}>
                      <img src={findMoreIcon} alt='find_more_icon' />
                    </Flex>
                  )
                }

                {this.renderActionBtn(item, item.id, item.name, item.price, item.options, item.discount, index, item.priceUndetermined, item.step, item.categoryId)}

              </div>
            </div>
          </div>
        )
      },

      ))

    return promoItem
  }

  stepperWithSlideTo = (index) => () => {
    this.swiper.slideTo(index, 500)
  }

  render () {
    const {
      classes,
      activeIndex,
      slideChange,
    } = this.props
    const wrapStyle = cx(classes.wrap)
    const reactSwiperParams = {
      slidesPerView: 2,
      centeredSlides: true,
      spaceBetween: 5,
      grabCursor: true,
      shouldSwiperUpdate: true,
      rebuildOnUpdate: false,
      ref: node => {
        if (node) {
          if (this.swiper) {
            this.swiper.off('slideChange')
          }

          this.swiper = node.swiper
          this.swiper.on('slideChange', () => {
            if (slideChange) {
              slideChange(this.swiper.activeIndex)
            }
          })

          if (activeIndex) {
            this.swiper.slideTo(activeIndex, 0)
          }
        }
      },
    }

    return (
      <div className={wrapStyle}>
        <ReactSwiper {...reactSwiperParams}>
          {this.renderCarouselItems()}
        </ReactSwiper>
      </div>
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(CarouselComponent)



// WEBPACK FOOTER //
// ./src/components/Carousel.js